"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.leverageSettingAPI = exports.leverageSettingCheckAPI = exports.reducePositionAPI = exports.reducePositionCheckAPI = exports.hedgeGridMarginRecordAPI = exports.hedgeGridMarginSettingAPI = exports.hedgeGridMarginSettingCheckAPI = exports.hedgeGridParamsCheckAPI = exports.withDrawProfitListAPI = exports.withDrawProfitAPI = exports.withDrawProfitCheckAPI = exports.DWMarginParamsCheckAPI = exports.pauseResumeCheckAPI = exports.adjustRecordListAPI = exports.cancelInvestInTrigger = exports.adjustParamsAPI = exports.adjustParamsCheckAPI = exports.gridV4FuturesRecommendAI = exports.gridV4FuturesAI = exports.tradeInfoAPI = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const interfaces_1 = require("./interfaces");
const lodash_1 = require("lodash");
function tradeInfoAPI(request) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + "/future_grid_v4/check/";
    if (request.leverage) {
        request.leverage = Number(request.leverage);
    }
    return trade_utils_lib_1.Network.post({ url: url, data: request, authType: trade_utils_lib_1.AuthType.Access });
}
exports.tradeInfoAPI = tradeInfoAPI;
function gridV4FuturesAI(request) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + "/future_grid_v4/ai_strategy/";
    return trade_utils_lib_1.Network.get({ url: url, data: request });
}
exports.gridV4FuturesAI = gridV4FuturesAI;
function gridV4FuturesRecommendAI(request) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + "/future_grid_v4/recommend/ai_strategy/";
    return trade_utils_lib_1.Network.get({ url: url, data: request, authType: trade_utils_lib_1.AuthType.Access });
}
exports.gridV4FuturesRecommendAI = gridV4FuturesRecommendAI;
// 订单修改预检查
function adjustParamsCheckAPI(params) {
    const { orderId } = params, data = __rest(params, ["orderId"]);
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    // const suffix = params.type === AdjustParamsType.adjust_params ? "adjust_params_check_v2" : "adjust_params_check";
    const url = host + `/future_grid_v4/${orderId}/adjust_params_check/`;
    return trade_utils_lib_1.Network.post({ url: url, data: data, authType: trade_utils_lib_1.AuthType.Access });
}
exports.adjustParamsCheckAPI = adjustParamsCheckAPI;
// 订单修改
function adjustParamsAPI(params) {
    const { orderId, quote_investment, type, extra_margin, top, bottom, row, extra_margin_amount, is_recommend, is_reinvest, condition, condition_direction, slippage, } = params;
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/future_grid_v4/${orderId}/adjust_params/`;
    const data = {
        type: type,
        quote_investment: quote_investment,
        extra_margin: extra_margin,
        open_price: params.open_price,
    };
    if (type === interfaces_1.AdjustParamsType.adjust_params) {
        data.top = top;
        data.bottom = bottom;
        data.row = row;
        data.extra_margin_amount = extra_margin_amount;
        data.is_recommend = is_recommend;
        data.is_reinvest = !!is_reinvest;
        // data.is_v2 = true;
    }
    if (type === interfaces_1.AdjustParamsType.invest_in_trigger) {
        data.condition = condition;
        data.condition_direction = condition_direction;
    }
    if (!(0, lodash_1.isNil)(slippage)) {
        data.slippage = slippage;
    }
    return trade_utils_lib_1.Network.post({ url: url, data: data, authType: trade_utils_lib_1.AuthType.Access });
}
exports.adjustParamsAPI = adjustParamsAPI;
// 撤销触发加仓
function cancelInvestInTrigger(params) {
    const { orderId, orderType } = params;
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/${orderType}/${orderId}/invest_in_trigger/cancel/`;
    return trade_utils_lib_1.Network.post({ url, authType: trade_utils_lib_1.AuthType.Access });
}
exports.cancelInvestInTrigger = cancelInvestInTrigger;
// 订单修改记录
function adjustRecordListAPI(orderId, orderType, page_token, limit = 10) {
    let host = "";
    if (orderType === TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid ||
        orderType === TradeAPILib_1.ExchangeOrderType.gridV4Futures ||
        orderType === TradeAPILib_1.ExchangeOrderType.futures_martingale) {
        host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    }
    else {
        host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST + "/orders";
    }
    const url = host + `/${orderType}/${orderId}/adjust_record_list/`;
    let params = { limit: limit };
    if (page_token) {
        params["page_token"] = page_token;
    }
    return trade_utils_lib_1.Network.get({ url: url, data: params, authType: trade_utils_lib_1.AuthType.Access });
}
exports.adjustRecordListAPI = adjustRecordListAPI;
// 暂停重启预检来获取预估强平价
function pauseResumeCheckAPI(params) {
    const { orderId } = params, data = __rest(params, ["orderId"]);
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/future_grid_v4/${orderId}/pause_resume_check/`;
    return trade_utils_lib_1.Network.post({ url: url, data: data, authType: trade_utils_lib_1.AuthType.Access });
}
exports.pauseResumeCheckAPI = pauseResumeCheckAPI;
// 充提保证金效验
function DWMarginParamsCheckAPI(request) {
    const { orderId, type, open_price, extra_margin } = request;
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/future_grid_v4/${orderId}/margin_transfer_check/`;
    const params = { type, open_price, extra_margin };
    return trade_utils_lib_1.Network.post({ url: url, data: params, authType: trade_utils_lib_1.AuthType.Access });
}
exports.DWMarginParamsCheckAPI = DWMarginParamsCheckAPI;
// 提取利润预检查
function withDrawProfitCheckAPI(request) {
    const { orderId } = request, data = __rest(request, ["orderId"]);
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/future_grid_v4/${orderId}/profit_transfer_check/`;
    return trade_utils_lib_1.Network.post({ url: url, data: data, authType: trade_utils_lib_1.AuthType.Access });
}
exports.withDrawProfitCheckAPI = withDrawProfitCheckAPI;
// 提取利润
function withDrawProfitAPI(request) {
    const { orderId } = request, data = __rest(request, ["orderId"]);
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/future_grid_v4/${orderId}/transfer/`;
    return trade_utils_lib_1.Network.post({ url: url, data: data, authType: trade_utils_lib_1.AuthType.Access });
}
exports.withDrawProfitAPI = withDrawProfitAPI;
// 获取提取利润记录
function withDrawProfitListAPI(orderId, orderType, page_token, type) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST;
    const url = host + `/orders/${orderType}/${orderId}/transfer/`;
    let urlParam = {};
    if (type) {
        urlParam.type = type;
    }
    if (page_token) {
        urlParam.page_token = page_token;
    }
    return trade_utils_lib_1.Network.get({ url, data: urlParam, authType: trade_utils_lib_1.AuthType.Access });
}
exports.withDrawProfitListAPI = withDrawProfitListAPI;
// 多空双开 合约网格下单预检查
function hedgeGridParamsCheckAPI(req) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = `${host}/future_hedge_grid/check/`;
    return trade_utils_lib_1.Network.post({ url, data: req, authType: trade_utils_lib_1.AuthType.Access });
}
exports.hedgeGridParamsCheckAPI = hedgeGridParamsCheckAPI;
// 多空双开 合约网格 调整保证金预检查
function hedgeGridMarginSettingCheckAPI(id, req) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = `${host}/future_hedge_grid/${id}/margin_transfer_check/`;
    return trade_utils_lib_1.Network.post({ url, data: req, authType: trade_utils_lib_1.AuthType.Access });
}
exports.hedgeGridMarginSettingCheckAPI = hedgeGridMarginSettingCheckAPI;
// 多空双开 合约网格 调整保证金 追加或提取
function hedgeGridMarginSettingAPI(id, req) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = `${host}/future_hedge_grid/${id}/transfer/`;
    return trade_utils_lib_1.Network.post({ url, data: req, authType: trade_utils_lib_1.AuthType.Access });
}
exports.hedgeGridMarginSettingAPI = hedgeGridMarginSettingAPI;
// 多空双开 合约网格 调整保证金记录获取
function hedgeGridMarginRecordAPI(id, req) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = `${host}/future_hedge_grid/${id}/transfer/`;
    return trade_utils_lib_1.Network.get({ url, data: req, authType: trade_utils_lib_1.AuthType.Access });
}
exports.hedgeGridMarginRecordAPI = hedgeGridMarginRecordAPI;
// 订单减仓预检查
function reducePositionCheckAPI(params, orderType) {
    const { orderId } = params, data = __rest(params, ["orderId"]);
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/${orderType}/${orderId}/reduce_check/`;
    return trade_utils_lib_1.Network.get({ url: url, data: data, authType: trade_utils_lib_1.AuthType.Access });
}
exports.reducePositionCheckAPI = reducePositionCheckAPI;
// 订单减仓
function reducePositionAPI(params, orderType) {
    const { orderId } = params, data = __rest(params, ["orderId"]);
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/${orderType}/${orderId}/reduce/`;
    return trade_utils_lib_1.Network.post({ url: url, data: data, authType: trade_utils_lib_1.AuthType.Access });
}
exports.reducePositionAPI = reducePositionAPI;
// 订单减仓预检查
function leverageSettingCheckAPI(params, orderType) {
    const { orderId } = params, data = __rest(params, ["orderId"]);
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/${orderType}/${orderId}/update_leverage_check/`;
    return trade_utils_lib_1.Network.post({ url: url, data: data, authType: trade_utils_lib_1.AuthType.Access });
}
exports.leverageSettingCheckAPI = leverageSettingCheckAPI;
// 订单减仓
function leverageSettingAPI(params, orderType) {
    const { orderId } = params, data = __rest(params, ["orderId"]);
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/${orderType}/${orderId}/update_leverage/`;
    return trade_utils_lib_1.Network.post({ url: url, data: data, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
}
exports.leverageSettingAPI = leverageSettingAPI;
